// extracted by mini-css-extract-plugin
export default {"wrapper":"SimpleTable_wrapper__FrjYl","row":"SimpleTable_row__GP-F-","rowTitle":"SimpleTable_rowTitle__lupVt","rowValue":"SimpleTable_rowValue__N-Gsk"};